import CmModal from "../Controls/CmModal";
import CustomButton from "../Controls/CustomButton";

/**
 * Read-only person notice viewer. Callers own selectedNotice state and mount this when set.
 */
export default function NoticeDetailsModal({ notice, onClose }) {
  const title = notice?.NoticeTypeDescription || "Notice";

  return (
    <CmModal
      open
      onClose={onClose}
      title={title}
      size="form"
      testId="notice-details-modal"
      footer={
        <CustomButton type="button" variant="contained" color="primary" onClick={onClose}>
          Close
        </CustomButton>
      }
    >
      {!notice ? (
        <p>Notice not found.</p>
      ) : (
        <div className="cm-modal-body-pad" data-testid="notice-details-body">
          <p>
            <strong>Time:</strong> {notice.NoticeTime || "—"}
          </p>
          <p>
            <strong>Message:</strong> {notice.Message || "—"}
          </p>
        </div>
      )}
    </CmModal>
  );
}
